// Production Environment
// This file contains environment used for giv (states that are not Arizona)

export const environment = {
	envName: 'prod',
	production: true,
	appName: 'AZGIV',
	authLogoUrl: 'assets/css/img/GIV_Logo_64x64.png',
	rootLink: 'https://gis-give.com/', // 'gis-give.com/ng911/', //'https://www.linearbench.com/AZGIV/',
	serviceRootUrl: 'https://api.linearbench.com/',
	portalRootLink: 'https://admin.linearbench.com/',
	socketConnectOption: {transports: ['websocket', 'polling']},
	idleTime: 600000,
	//
	elasticsearchHost: 'http://192.168.88.39:9200/',
	//
	loginPortal: 'LBPortal',
	lbPortalRegisterUrl: 'https://admin.linearbench.com/auth/register',
	lbPortalPwResetUrl: 'https://admin.linearbench.com/auth/retrieve-pw'
};
